import Axios from "axios";
import React, { Component } from "react";
import { Bar } from "react-chartjs-2";
import AppConfig from "../../../../../config/AppConfig";
class ChartSebaranSPMIBerdasarkanWilayah extends Component {
  constructor(props) {
    super(props);
    this.state = {
      label: [],
      politeknik: [],
      akademi: [],
      akademi_komunitas: [],
      sekolah_tinggi: [],
      institut: [],
      universitas: [],
      loading: false,
    };
  }

  options = {
    scales: {
      yAxes: [
        {
          ticks: {
            beginAtZero: true,
            userCallback: function(label, index, labels) {
              // when the floored value is the same as the value we have a whole number
              if (Math.floor(label) === label) {
                return label;
              }
            },
          },
        },
      ],
    },
    plugins: {
      legend: {
        display: true,
        position: "bottom",
      },
    },
  };
  getData() {
    this.setState({
      loading: true,
    });
    let id_institusi = localStorage.getItem("id_sp_temp");
    let sessiondata = JSON.parse(localStorage.getItem("sessiondata"));
    let id_sp = sessiondata.i_idunit;
    if (id_institusi !== "") {
      id_sp = id_institusi;
    }
    if (id_institusi === null) {
      id_sp = sessiondata.i_idunit;
    }
    let session = "";
    let userdata = JSON.parse(localStorage.getItem("userdata"));
    if (userdata) {
      session =
        "?tipe_lembaga=" +
        this.props.tipe_lembaga +
        "&id_pengguna=" +
        userdata.id_pengguna +
        "&id_unit=" +
        id_sp +
        "&id_role=" +
        sessiondata.i_idrole;
    }
    let i = 0;
    let labels = [];
    let politeknik = [];
    let akademi = [];
    let akademi_komunitas = [];
    let sekolah_tinggi = [];
    let institut = [];
    let universitas = [];
    Axios.get(AppConfig.DetailDashboard + "sebaranptvbywilayah" + session)
      .then((res) => {
        for (var key in res.data.result.data_belmawa) {
          labels[i] = key;
          politeknik[i] = res.data.result.data_belmawa[key].politeknik;
          akademi[i] = res.data.result.data_belmawa[key].akademi;
          akademi_komunitas[i] =
            res.data.result.data_belmawa[key].akademi_komunitas;
          sekolah_tinggi[i] = res.data.result.data_belmawa[key].sekolah_tinggi;
          institut[i] = res.data.result.data_belmawa[key].institut;
          universitas[i] = res.data.result.data_belmawa[key].universitas;
          i = i + 1;
        }

        this.setState({
          label: labels,
          politeknik: politeknik,
          akademi: akademi,
          akademi_komunitas: akademi_komunitas,
          sekolah_tinggi: sekolah_tinggi,
          institut: institut,
          universitas: universitas,
          loading: false,
        });
      })
      .catch((err) => {
        alert("not found");
      });
  }
  async componentDidMount() {
    this.getData();
  }
  async componentDidUpdate() {
    if (this.props.status === true) {
      this.getData();
      this.props.parentCallback(false);
    }
  }
  render() {
    let datas = {
      labels: this.state.label,
      datasets: [
        {
          label: "Politeknik",
          fill: false,
          lineTension: 0.1,
          backgroundColor: "#ED3975",
          borderColor: "#ED3975",
          borderCapStyle: "butt",
          borderDash: [],
          borderDashOffset: 0.0,
          borderJoinStyle: "miter",
          pointBorderColor: "#ED3975",
          pointBackgroundColor: "#ED3975",
          pointBorderWidth: 1,
          pointHoverRadius: 5,
          pointHoverBackgroundColor: "#ED3975",
          pointHoverBorderColor: "#ED3975",
          pointHoverBorderWidth: 2,
          pointRadius: 1,
          pointHitRadius: 10,
          data: this.state.politeknik,
        },
        {
          label: "Akademi",
          fill: false,
          lineTension: 0.1,
          backgroundColor: "#B73BF7",
          borderColor: "#B73BF7",
          borderCapStyle: "butt",
          borderDash: [],
          borderDashOffset: 0.0,
          borderJoinStyle: "miter",
          pointBorderColor: "#B73BF7",
          pointBackgroundColor: "#B73BF7",
          pointBorderWidth: 1,
          pointHoverRadius: 5,
          pointHoverBackgroundColor: "#B73BF7",
          pointHoverBorderColor: "#B73BF7",
          pointHoverBorderWidth: 2,
          pointRadius: 1,
          pointHitRadius: 10,
          data: this.state.akademi,
        },
        {
          label: "Akademi Komunitas",
          fill: false,
          lineTension: 0.1,
          backgroundColor: "#4149E0",
          borderColor: "#4149E0",
          borderCapStyle: "butt",
          borderDash: [],
          borderDashOffset: 0.0,
          borderJoinStyle: "miter",
          pointBorderColor: "#4149E0",
          pointBackgroundColor: "#4149E0",
          pointBorderWidth: 1,
          pointHoverRadius: 5,
          pointHoverBackgroundColor: "#4149E0",
          pointHoverBorderColor: "#4149E0",
          pointHoverBorderWidth: 2,
          pointRadius: 1,
          pointHitRadius: 10,
          data: this.state.akademi_komunitas,
        },
        {
          label: "Sekolah Tinggi",
          fill: false,
          lineTension: 0.1,
          backgroundColor: "#3EC8FA",
          borderColor: "#3EC8FA",
          borderCapStyle: "butt",
          borderDash: [],
          borderDashOffset: 0.0,
          borderJoinStyle: "miter",
          pointBorderColor: "#3EC8FA",
          pointBackgroundColor: "#3EC8FA",
          pointBorderWidth: 1,
          pointHoverRadius: 5,
          pointHoverBackgroundColor: "#3EC8FA",
          pointHoverBorderColor: "#3EC8FA",
          pointHoverBorderWidth: 2,
          pointRadius: 1,
          pointHitRadius: 10,
          data: this.state.sekolah_tinggi,
        },
        {
          label: "Institut",
          fill: false,
          lineTension: 0.1,
          backgroundColor: "#39ED9C",
          borderColor: "#39ED9C",
          borderCapStyle: "butt",
          borderDash: [],
          borderDashOffset: 0.0,
          borderJoinStyle: "miter",
          pointBorderColor: "#39ED9C",
          pointBackgroundColor: "#39ED9C",
          pointBorderWidth: 1,
          pointHoverRadius: 5,
          pointHoverBackgroundColor: "#39ED9C",
          pointHoverBorderColor: "#39ED9C",
          pointHoverBorderWidth: 2,
          pointRadius: 1,
          pointHitRadius: 10,
          data: this.state.institut,
        },
        {
          label: "Universitas",
          fill: false,
          lineTension: 0.1,
          backgroundColor: "#F0B040",
          borderColor: "#F0B040",
          borderCapStyle: "butt",
          borderDash: [],
          borderDashOffset: 0.0,
          borderJoinStyle: "miter",
          pointBorderColor: "#F0B040",
          pointBackgroundColor: "#F0B040",
          pointBorderWidth: 1,
          pointHoverRadius: 5,
          pointHoverBackgroundColor: "#F0B040",
          pointHoverBorderColor: "#F0B040",
          pointHoverBorderWidth: 2,
          pointRadius: 1,
          pointHitRadius: 10,
          data: this.state.universitas,
        },
      ],
    };
    return (
      <>
        {this.state.loading === true ? (
          <span className="ml-3 spinner spinner-black"></span>
        ) : (
          <Bar data={datas} options={this.options} />
        )}
      </>
    );
  }
}
export default ChartSebaranSPMIBerdasarkanWilayah;
